<template>
  <section id="welcome" class="overflow-hidden">
    <admin-app-bar />
    <v-row no-gutters>
      <v-col cols="12" class="welcome-background"></v-col>

      <v-col class="pa-5" cols="12" v-if="getStatus == 'success'">
        <v-row align="center" justify="center">
          <v-col cols="12" md="8" lg="8">
            <heading tag="h1">You're booked!</heading>
            <base-text
              >We've got you scheduled for a Virtual House Pro call on
              {{ this.convertToDate(bookingDetails.day) }} at
              {{ bookingDetails.slot.starts_at }}. We can't wait to see you! An
              email has been sent to you with all the info for the call. We're
              also including it below. Thanks!</base-text
            >
            <v-card class="mx-auto pa-3 mb-5">
              <v-card-text class="pb-0">Your date and time:</v-card-text>
              <v-card-title class="pt-2">{{
                `${this.convertToDate(bookingDetails.day)} at
                ${bookingDetails.slot.starts_at}`
              }}</v-card-title>

              <v-list class="pl-3">
                <v-list-item-group color="primary">
                  <v-list-item
                    v-for="(item, i) in bookingDetails.formData"
                    :key="i"
                    inactive
                    >{{ i | capitalizeFirstLetter }}: {{ item }}</v-list-item
                  >
                </v-list-item-group>
              </v-list>
            </v-card>
            <v-btn class="primary secondary--text" to="faqs" x-large>
              Read the FAQs
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12"></v-col>
    </v-row>
  </section>
</template>

<script>
import axios from "axios";
import UtilsMixin from "../../mixins/UtilsMixin";
import BaseText from "@/components/base/Text";
import Heading from "@/components/base/Heading";
import AdminAppBar from "@/components/core/AdminAppBar";

export default {
  name: "CoreView",
  mixins: [UtilsMixin],
  components: {
    BaseText,
    Heading,
    AdminAppBar,
  },
  computed: {
    getStatus() {
      return this.$store.getters.status;
    },
    bookingDetails() {
      return this.$store.getters.bookingDetails;
    },
    sendEmailURI() {
      return process.env.NODE_ENV === "development"
        ? this.sendEmailLOCAL
        : this.sendEmailProd;
    },
    sendEmailToMattURI() {
      return process.env.NODE_ENV === "development"
        ? this.sendEmailToMattLOCAL
        : this.sendEmailToMattProd;
    },
    sendEmailLOCAL() {
      return `${this.localBase}/sendEmail`;
    },
    sendEmailProd() {
      return `${this.prodBase}/sendEmail`;
    },
    sendEmailToMattLOCAL() {
      return `${this.localBase}/sendEmailToMatt`;
    },
    sendEmailToMattProd() {
      return `${this.prodBase}/sendEmailToMatt`;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.paid === "t") {
      // can use trickery and access 'this' by passing in vm instead
      next((vm) => {
        vm.$store.commit("setStatus", "success");
      });
    } else {
      // if our route doesn't include the query param, we are going to redirect to /schedule and prevent sending emails and booking
      next({ path: "/schedule" });
    }
  },
  mounted() {
    // get booking data
    const bookingData = this.$store.getters.bookingDetails;
    // have we sent an email to the customer before?
    const emailStatus = this.$store.getters.emailSentToCustomer;
    // have we sent an email to matt before??
    const adminEmailStatus = this.$store.getters.emailSentToAdmin;
    // was the user already booked??
    const bookedStatus = this.$store.getters.booked;

    // try to book
    this.bookAppointment(bookingData, bookedStatus);
    // try to send customer email
    this.sendEmail(bookingData, emailStatus);
    // try to send admin email
    this.sendEmailToMatt(bookingData, adminEmailStatus);
  },
  methods: {
    bookAppointment({ slot, index, day, formData }, bookedStatus) {
      if (!bookedStatus) {
        this.$store
          .dispatch("bookAppointmentAction", {
            slot,
            index,
            day,
            formData,
          })
          .catch((err) => this.$store.commit("setError", err));
      } else {
        console.log("already booked...");
        return;
      }
    },
    async sendEmailCloudFunction(formData, date) {
      try {
        const response = await axios.post(this.sendEmailURI, {
          formData,
          date,
        });
        console.log(response);
        if (response.status === 200) {
          this.$store.commit("setEmailSentToCustomer", true);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async sendEmailToMattCloudFunction(formData, date) {
      try {
        const response = await axios.post(this.sendEmailToMattURI, {
          formData,
          date,
        });
        console.log(response);
        if (response.status === 200) {
          this.$store.commit("setEmailSentToAdmin", true);
        }
      } catch (err) {
        console.log(err);
      }
    },
    sendEmail({ day, formData, slot }, emailStatus) {
      if (!emailStatus) {
        const formattedDate = this.joinDateAndTime(day, slot);
        this.sendEmailCloudFunction(formData, formattedDate);
      } else {
        console.log("email sent out previously...");
        return;
      }
    },
    sendEmailToMatt({ day, formData, slot }, adminEmailStatus) {
      if (!adminEmailStatus) {
        const formattedDate = this.joinDateAndTime(day, slot);
        this.sendEmailToMattCloudFunction(formData, formattedDate);
      } else {
        console.log("email sent to admin previously...");
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.welcome-background {
  background-image: url("../../assets/vhp_bkg@2x.jpg");
  background-size: cover;
  background-position: center center;
  position: relative;
  width: 100%;
  height: 28vh;

  @media (min-width: 768px) {
    height: 45vh;
  }

  .welcome-logo {
    position: absolute;
    top: 5%;
    left: 5%;
  }
}
</style>
